import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperPlane: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPaperPlane"><Path d="M9.5 12H6.25M3 3L21 12L3 21L6 12L3 3Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPaperPlane;
